function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from 'styled-components';
import colors from "../../../colors/index";
import Text from "../../Typography/Text";
import { formatWeightToCommaSeparated } from "../helpers";
import { EnumProductType } from "../types";
import { calcQuantity } from "../../QuantityControls/helpers";
import { hideBeforeSm } from "../../../theme/helpers/media";
var Wrapper = styled(Text).attrs(function (_ref) {
  var _theme$quantityText;

  var theme = _ref.theme;
  return {
    size: 200,
    fontWeight: theme === null || theme === void 0 ? void 0 : (_theme$quantityText = theme.quantityText) === null || _theme$quantityText === void 0 ? void 0 : _theme$quantityText.fontWeight
  };
}).withConfig({
  displayName: "ListQuantity__Wrapper",
  componentId: "bq4end-0"
})(["display:block;color:", ";overflow:hidden;white-space:nowrap;width:100%;"], colors.warmGrey);
var Pretext = styled(Text).withConfig({
  displayName: "ListQuantity__Pretext",
  componentId: "bq4end-1"
})(["padding-right:5px;", ";"], hideBeforeSm);
export var CartQuantity = function CartQuantity(_ref2) {
  var _EnumProductType$pack;

  var weight = _ref2.weight,
      amount = _ref2.amount,
      type = _ref2.type,
      className = _ref2.className,
      measure = _ref2.measure;
  return React.createElement(Wrapper, {
    className: className
  }, React.createElement(Pretext, null, "\u0437\u0430"), (_EnumProductType$pack = {}, _defineProperty(_EnumProductType$pack, EnumProductType.pack, "".concat(calcQuantity(amount, weight, false), " \u0448\u0442.")), _defineProperty(_EnumProductType$pack, EnumProductType.weight, "".concat(calcQuantity(amount, weight, true), " ").concat(measure)), _defineProperty(_EnumProductType$pack, EnumProductType.piece, "".concat(calcQuantity(amount, weight, false), " \u0448\u0442.")), _EnumProductType$pack)[type]);
};

var Quantity = function Quantity(_ref3) {
  var _EnumProductType$pack2;

  var display_weight = _ref3.display_weight,
      type = _ref3.type,
      className = _ref3.className;
  return React.createElement(Wrapper, {
    className: className
  }, (_EnumProductType$pack2 = {}, _defineProperty(_EnumProductType$pack2, EnumProductType.pack, 'фас.'), _defineProperty(_EnumProductType$pack2, EnumProductType.weight, 'вес.'), _defineProperty(_EnumProductType$pack2, EnumProductType.piece, formatWeightToCommaSeparated(display_weight)), _EnumProductType$pack2)[type]);
};

export default Quantity;